import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
import React from "react";
import { m, useScroll, useTransform, useMotionTemplate } from "framer-motion";
type Props = {
  text: string;
};
function Line(props: {
  line: string;
  index: number;
}) {
  const {
    line,
    index
  } = props;
  const ref = React.useRef<HTMLSpanElement>(null);
  const fillRange = 0.1;
  const startProgress = index * fillRange;
  const endProgress = startProgress + fillRange;
  const adjustedEndProgress = Math.min(endProgress, 1);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ["start 80%", "end start"]
  });
  const scrollValue = useTransform(scrollYProgress, [startProgress, adjustedEndProgress], ["100%", "0%"]);
  const clipPath = useMotionTemplate`inset(0% ${scrollValue} 0% 0%)`;
  return <_StyledSpan ref={ref} aria-hidden>
      {/* Base (Inactive) Text */}
      <_StyledSpan2>{line}</_StyledSpan2>

      {/* Overlay (Active/Highlighted) Text */}
      <_StyledMSpan style={{
      clipPath,
      transition: "clip-path 0.3s ease-out"
    }}>
        {line}
      </_StyledMSpan>
    </_StyledSpan>;
}
export function ScrollHighlightText(props: Props) {
  const {
    text
  } = props;
  const lines = text.split("\n");
  return <p>
      <_StyledSpan3>{text}</_StyledSpan3>
      {lines.map((line, idx) => <Line key={idx} line={line} index={idx} />)}
    </p>;
}
var _StyledSpan = _styled("span").withConfig({
  componentId: "sc-sf-1dxzfnb-0"
})({
  "position": "relative",
  "display": "block"
});
var _StyledSpan2 = _styled2("span").withConfig({
  componentId: "sc-sf-1dxzfnb-1"
})({
  "fontSize": "2.8rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(108 112 97 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "5.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.054000000000000006rem",
    "fontWeight": "400"
  }
});
var _StyledMSpan = _styled3(m.span).withConfig({
  componentId: "sc-sf-1dxzfnb-2"
})({
  "position": "absolute",
  "inset": "0",
  "fontSize": "2.8rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "5.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.054000000000000006rem",
    "fontWeight": "400"
  }
});
var _StyledSpan3 = /*#__PURE__*/_styled4("span").withConfig({
  displayName: "scroll-highlight-text___StyledSpan3",
  componentId: "sc-z1yyxb-0"
})({
  "position": "absolute",
  "width": "1px",
  "height": "1px",
  "padding": "0",
  "margin": "-1px",
  "overflow": "hidden",
  "clip": "rect(0, 0, 0, 0)",
  "whiteSpace": "nowrap",
  "borderWidth": "0"
});